import { render } from "./WindowDestination.vue?vue&type=template&id=78671a0e&scoped=true"
import script from "./WindowDestination.vue?vue&type=script&lang=js"
export * from "./WindowDestination.vue?vue&type=script&lang=js"

import "./WindowDestination.vue?vue&type=style&index=0&id=78671a0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78671a0e"

export default script